import { useEffect, useState } from "react";

/**
 * Tracks the active index into a gallery of images for click-driven (not
 * auto-advancing) browsing — e.g. hover arrows + dot indicators on a tile.
 * Resets to 0 whenever the image list's *content* changes (a different
 * product mapped into this slot), even though a fresh array is typically
 * passed in on every render.
 */
export const useImageGalleryIndex = (
  images: string[]
): [number, (next: number) => void] => {
  const [index, setIndex] = useState(0);
  const imagesKey = images.join("|");

  useEffect(() => {
    setIndex(0);
  }, [imagesKey]);

  const setWrappedIndex = (next: number): void => {
    if (images.length === 0) return;
    setIndex(((next % images.length) + images.length) % images.length);
  };

  return [index, setWrappedIndex];
};
